// ── SHOPIFY CART CONFIG ──
const VARIANT_ID = '51631606038845';
const PRICE_PER_DOZEN = 549;
const BALLS_PER_DOZEN = 12;
const FREE_SHIP = 999;
const MIN_QTY = 1;
const MAX_QTY = 12;

let qty = 1;
function fmt(n){return '$'+n.toLocaleString('es-MX');}

function render(){
  var balls = qty * BALLS_PER_DOZEN;
  var total = qty * PRICE_PER_DOZEN;
  var noun = qty===1?'docena':'docenas';
  document.querySelectorAll('[data-qty]').forEach(function(e){e.textContent = qty;});
  document.querySelectorAll('[data-qty-noun]').forEach(function(e){e.textContent = noun;});
  document.querySelectorAll('[data-qty-balls]').forEach(function(e){e.textContent = balls;});
  document.querySelectorAll('[data-qty-total]').forEach(function(e){e.textContent = fmt(total);});
  document.querySelectorAll('[data-price]').forEach(function(e){e.textContent = fmt(total);});
  var pct = Math.min(100, Math.round(total/FREE_SHIP*100));
  document.querySelectorAll('[data-ship-fill]').forEach(function(e){e.style.width = pct+'%';});
  var msg = total>=FREE_SHIP ? '¡Felicidades! Tienes envío gratis ❄' : 'Agrega otra docena y recibe envío gratis';
  document.querySelectorAll('[data-ship-msg]').forEach(function(e){e.textContent = msg;});
  document.querySelectorAll('.qbtn-mini-minus, .qbtn.minus').forEach(function(b){b.disabled = qty<=MIN_QTY;});
  document.querySelectorAll('.qbtn-mini-plus, .qbtn.plus').forEach(function(b){b.disabled = qty>=MAX_QTY;});
}
function step(d){ qty = Math.max(MIN_QTY, Math.min(MAX_QTY, qty+d)); render(); }
function goBuy(){ closeDrawer(); var el = document.getElementById('comprar'); if(el) el.scrollIntoView({behavior:'smooth'}); }

// ── SHOPIFY CHECKOUT ──
function submitBuyForm(){
  var form = document.createElement('form');
  form.method = 'POST';
  form.action = '/cart/add';
  form.style.display = 'none';
  function add(name, value){
    var input = document.createElement('input');
    input.type='hidden'; input.name=name; input.value=value;
    form.appendChild(input);
  }
  add('id', VARIANT_ID);
  add('quantity', String(qty));
  add('return_to', '/checkout');
  document.body.appendChild(form);
  form.submit();
}

function checkout(){
  if(window.location.protocol === 'file:'){
    alert('⚠ Preview local. El checkout solo funciona en Shopify.\n\nPedido: '+qty+(qty===1?' docena':' docenas')+' — '+fmt(qty*PRICE_PER_DOZEN));
    return;
  }
  // Clear cart first so we replace, not stack
  fetch('/cart/clear.js', {method:'POST'})
    .then(submitBuyForm)
    .catch(function(){ submitBuyForm(); });
}

// ── TICKER + STRIP marquees (width-aware, siempre llenan la barra) ──
(function(){
  var t = ['Envío gratis a partir de 2 docenas','Envíos a todo México'];
  var s = ['Soft Ice','2PC Urethane','Play it cool'];
  function pass(arr){ var h=''; arr.forEach(function(x){ h+='<span>'+x+'</span>'; }); return h; }
  function marquee(el, arr){
    if(!el) return;
    var container = el.parentElement;
    function build(passes){
      var half=''; for(var p=0;p<passes;p++){ half+=pass(arr); }
      el.innerHTML = half + half;           // dos mitades idénticas → -50% sin saltos
    }
    function passWidth(){
      el.innerHTML = pass(arr);             // una sola pasada para medir su ancho real
      var w=0, ch=el.children;
      for(var i=0;i<ch.length;i++){ w += ch[i].getBoundingClientRect().width; }
      return w || 1;
    }
    function fit(){
      var onePass = passWidth();            // ancho real del contenido (no del track estirado)
      var need = Math.max(2, Math.ceil((container.clientWidth*1.6)/onePass));
      build(need);
    }
    fit();
    var to; window.addEventListener('resize', function(){ clearTimeout(to); to=setTimeout(fit,150); });
    window.addEventListener('load', fit);                       // re-medir tras layout final
    if(document.fonts && document.fonts.ready){ document.fonts.ready.then(fit); } // y tras cargar la fuente
  }
  marquee(document.getElementById('tick'), t);
  marquee(document.getElementById('strip'), s);
})();

// ── DRAWER ──
function openDrawer(){
  document.getElementById('drawer').classList.add('open');
  document.getElementById('overlay').classList.add('open');
}
function closeDrawer(){
  document.getElementById('drawer').classList.remove('open');
  document.getElementById('overlay').classList.remove('open');
}

// ── PRODUCT CAROUSEL ──
(function(){
  var car = document.getElementById('pcardCarousel');
  var dotsWrap = document.getElementById('pcardDots');
  if(!car || !dotsWrap) return;
  var track = car.querySelector('.pcard-track');
  var slides = track.querySelectorAll('.pcard-slide');
  var dots = dotsWrap.querySelectorAll('.pcard-dot');
  if(!slides.length) return;

  function current(){ return Math.round(track.scrollLeft / track.clientWidth); }
  function goTo(i){
    i = Math.max(0, Math.min(slides.length-1, i));
    track.scrollTo({left: i*track.clientWidth, behavior:'smooth'});
  }
  track.addEventListener('scroll', function(){
    var idx = current();
    dots.forEach(function(d,k){ d.classList.toggle('active', k===idx); });
  });
  dots.forEach(function(d,k){ d.addEventListener('click', function(){ goTo(k); }); });

  car.querySelectorAll('[data-carousel-prev]').forEach(function(b){
    b.addEventListener('click', function(){ goTo(current()-1); });
  });
  car.querySelectorAll('[data-carousel-next]').forEach(function(b){
    b.addEventListener('click', function(){ goTo(current()+1); });
  });
})();

// ── CONSTRUCTION CAROUSEL DOTS (mobile) ──
(function(){
  var grid = document.getElementById('consGrid');
  var dotsWrap = document.getElementById('consDots');
  if(!grid || !dotsWrap) return;
  var dots = dotsWrap.querySelectorAll('.cons-dot');
  var cards = grid.querySelectorAll('.layer');
  if(!dots.length || !cards.length) return;
  function step(){ return cards.length>1 ? (cards[1].offsetLeft - cards[0].offsetLeft) : cards[0].offsetWidth; }
  grid.addEventListener('scroll', function(){
    var idx = Math.round(grid.scrollLeft / step());
    idx = Math.max(0, Math.min(cards.length-1, idx));
    dots.forEach(function(d,k){ d.classList.toggle('active', k===idx); });
  });
  dots.forEach(function(d,k){
    d.addEventListener('click', function(){
      grid.scrollTo({left: k*step(), behavior:'smooth'});
    });
  });
})();

// ── LIGHTBOX (zoom para todas las fotos) ──
(function(){
  var lb = document.getElementById('lightbox');
  var img = document.getElementById('lbImg');
  var stage = document.getElementById('lbStage');
  if(!lb || !img) return;
  var scale=1, tx=0, ty=0, minS=1, maxS=4;

  function apply(){ img.style.transform='translate('+tx+'px,'+ty+'px) scale('+scale+')'; img.classList.toggle('zoomed', scale>1.01); }
  function reset(){ scale=1; tx=0; ty=0; apply(); }
  function open(src, alt){ img.src=src; img.alt=alt||''; reset(); lb.classList.add('open'); lb.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; }
  function close(){ lb.classList.remove('open'); lb.setAttribute('aria-hidden','true'); document.body.style.overflow=''; }

  document.addEventListener('click', function(e){
    var z = e.target.closest('img[data-zoom]');
    if(z){ open(z.getAttribute('data-full')||z.currentSrc||z.src, z.alt); return; }
    if(e.target.closest('[data-act="lb-close"]')){ close(); }
  });
  lb.addEventListener('click', function(e){ if(e.target===lb || e.target===stage){ close(); } });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape' && lb.classList.contains('open')) close(); });

  // rueda (desktop)
  lb.addEventListener('wheel', function(e){
    if(!lb.classList.contains('open')) return;
    e.preventDefault();
    scale = Math.max(minS, Math.min(maxS, scale + (e.deltaY<0?0.25:-0.25)));
    if(scale<=1){ tx=0; ty=0; }
    apply();
  }, {passive:false});

  // doble clic / doble toque
  img.addEventListener('dblclick', function(e){ e.preventDefault(); if(scale>1) reset(); else { scale=2.4; apply(); } });

  // arrastre con mouse
  var drag=false, sx=0, sy=0, stx=0, sty=0;
  img.addEventListener('mousedown', function(e){ if(scale<=1) return; drag=true; sx=e.clientX; sy=e.clientY; stx=tx; sty=ty; e.preventDefault(); });
  window.addEventListener('mousemove', function(e){ if(!drag) return; tx=stx+(e.clientX-sx); ty=sty+(e.clientY-sy); apply(); });
  window.addEventListener('mouseup', function(){ drag=false; });

  // touch: pellizco para zoom + un dedo para mover
  var pts={}, startDist=0, startScale=1, ptx=0, pty=0, psx=0, psy=0, lastTap=0;
  function dist(a,b){ var dx=a.x-b.x, dy=a.y-b.y; return Math.sqrt(dx*dx+dy*dy); }
  img.addEventListener('touchstart', function(e){
    pts={};
    for(var i=0;i<e.touches.length;i++){ var t=e.touches[i]; pts[t.identifier]={x:t.clientX,y:t.clientY}; }
    var ids=Object.keys(pts);
    if(ids.length===2){ startDist=dist(pts[ids[0]],pts[ids[1]]); startScale=scale; }
    else if(ids.length===1){
      psx=e.touches[0].clientX; psy=e.touches[0].clientY; ptx=tx; pty=ty;
      var now=Date.now(); if(now-lastTap<300){ if(scale>1) reset(); else { scale=2.4; apply(); } } lastTap=now;
    }
  }, {passive:false});
  img.addEventListener('touchmove', function(e){
    if(e.touches.length===2){
      e.preventDefault();
      var a={x:e.touches[0].clientX,y:e.touches[0].clientY}, b={x:e.touches[1].clientX,y:e.touches[1].clientY};
      scale=Math.max(minS, Math.min(maxS, startScale*(dist(a,b)/(startDist||1)))); apply();
    } else if(e.touches.length===1 && scale>1){
      e.preventDefault();
      tx=ptx+(e.touches[0].clientX-psx); ty=pty+(e.touches[0].clientY-psy); apply();
    }
  }, {passive:false});
  img.addEventListener('touchend', function(){ if(scale<=1) reset(); });
})();

// ── RESEÑAS: carrusel (auto en desktop vía CSS; auto + swipe en mobile vía JS) ──
(function(){
  var marquee = document.querySelector('.rev-marquee');
  var track = document.querySelector('[data-rev-track]');
  if(!marquee || !track) return;
  track.innerHTML += track.innerHTML; // duplica las tarjetas para un loop continuo

  var mq = window.matchMedia('(max-width:880px)');
  var reduce = window.matchMedia('(prefers-reduced-motion:reduce)');
  var raf = null, paused = false, resumeTimer = null;

  // Loop infinito: la 2ª mitad es copia de la 1ª, así que al cruzar la mitad
  // retrocedemos medio ancho sin salto visible. Aplica a auto Y a scroll manual.
  function wrap(){
    var half = marquee.scrollWidth / 2;
    if(half > 0 && marquee.scrollLeft >= half){ marquee.scrollLeft -= half; }
  }
  function loop(){
    if(!paused){ marquee.scrollLeft += 0.3; }    // velocidad lenta en mobile
    wrap();
    raf = requestAnimationFrame(loop);
  }
  function pause(){                              // el cliente toca → pausa y puede navegar
    paused = true;
    clearTimeout(resumeTimer);
    resumeTimer = setTimeout(function(){ paused = false; }, 2500);
  }
  function enableMobile(){
    if(raf || marquee.dataset.revMobile === '1') return;
    marquee.dataset.revMobile = '1';
    marquee.addEventListener('touchstart', pause, {passive:true});
    marquee.addEventListener('pointerdown', pause, {passive:true});
    marquee.addEventListener('wheel', pause, {passive:true});
    marquee.addEventListener('scroll', wrap, {passive:true}); // loop en scroll manual
    if(!reduce.matches) raf = requestAnimationFrame(loop);     // reduced-motion: solo swipe manual
  }
  function disableMobile(){
    if(raf){ cancelAnimationFrame(raf); raf = null; }
    paused = false; clearTimeout(resumeTimer);
    marquee.dataset.revMobile = '0';
    marquee.removeEventListener('touchstart', pause);
    marquee.removeEventListener('pointerdown', pause);
    marquee.removeEventListener('wheel', pause);
    marquee.removeEventListener('scroll', wrap);
    marquee.scrollLeft = 0;
  }
  function apply(){ if(mq.matches) enableMobile(); else disableMobile(); }
  apply();
  if(mq.addEventListener) mq.addEventListener('change', apply);
  else if(mq.addListener) mq.addListener(apply);
})();

// ── REVEAL ON SCROLL ──
(function(){
  var els = document.querySelectorAll('.reveal');
  if(!els.length) return;
  var io = new IntersectionObserver(function(en){
    en.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); }});
  }, {threshold:.12});
  els.forEach(function(e){ io.observe(e); });
})();

// ── EVENT DELEGATION (robust on Shopify) ──
document.addEventListener('click', function(e){
  var el = e.target.closest('[data-act]');
  if(!el) return;
  if(el.disabled) return;
  var act = el.getAttribute('data-act');
  if(act === 'dec') step(-1);
  else if(act === 'inc') step(1);
  else if(act === 'buy') checkout();
  else if(act === 'gobuy') goBuy();
  else if(act === 'open-drawer') openDrawer();
  else if(act === 'close-drawer') closeDrawer();
});

// Init pricing
document.addEventListener('DOMContentLoaded', render);
render();
